import {LanguageDto, ModeltypeBasicDto, ModelBasicNameDto, TypefamilyDto, OSPGenerationDto} from "../../services/Client";
import {IMultiLineValue, lang2flag} from "../../components/MultiLineColumn";
import * as _ from "lodash";
import { LanguageCodeEnum } from "../AdminView/LanguageTab/LanguageTable";

/** adapter for data to handle other presentation of some data */
export default class DataAdapterModeltypeBasic {
    constructor(private val: ModeltypeBasicDto,
                public languages: LanguageDto[]) {
        this.getText = this.getText.bind(this);
        this.setText = this.setText.bind(this);
    }

    get value() {
        return this.val;
    }
    get visible() {
        return this.value.visible || false;
    }
    set visible(newValue: boolean) {
        this.value.visible = newValue;
    }

    get objectId() {
        return this.value.objectId;
    }

    get btyp() {
        return this.value.btyp;
    }

    set btyp(newValue: string | undefined) {
        this.value.btyp = newValue && newValue.length > 0 ? newValue : undefined;
    }

    get name(): IMultiLineValue[] {
        return this.getText('name');
    }

    set name(newValue: IMultiLineValue[]) {
        this.setText('name', newValue);
    }

    get names(): ModelBasicNameDto[] {
        return this.val.names ? this.val.names : [];
    }
    get generation(): OSPGenerationDto {
      return this.value.generation;
    }
    set generation(newValue: OSPGenerationDto) {
        this.value.generation = newValue;
    }

    set names(newValue: ModelBasicNameDto[]) {
        const names: ModelBasicNameDto[] = newValue
            .filter((value: ModelBasicNameDto) => (value.objectId > 0 || (value.name && value.name.length > 0)));

        names.forEach((value: ModelBasicNameDto) => {
            if (value.name === "") {
                value.name = undefined;
            }
        });
        this.val.names = names;
    }

    get typefamily() {
        return this.value.typefamily;
    }

    set typefamily(newValue: TypefamilyDto) {
        this.value.typefamily = newValue;
    }

    get textExportDate(): Date | undefined {
        return this.val.textExportDate;
    }
    get textExportStatus(): string | undefined {
        return this.val.textExportStatus;
    }
    
    get intSequence() {
        return this.value.intSequence;
    }

    set intSequence(newValue: number | undefined) {
        this.value.intSequence = newValue === undefined ? 999 : newValue;
    }

    get color() {
        return this.value.color;
    }

    set color(newValue: string | undefined) {
        this.value.color = newValue;
    }

    get pdipFlag() {
        return this.value.pdipFlag;
    }

    get changedBy() {
        return this.value.metadata ?  this.value.metadata.changedBy : undefined;
    }

    get changedTimestamp() {
        return this.value.metadata ? this.value.metadata.changedTimestamp : undefined;
    }

    get pccdFlag() {
        return this.val.pccdFlag;
    }

    private getText(key: string): IMultiLineValue[] {
        const languages = this.languages.filter(lang => [LanguageCodeEnum.BASIC_GERMAN.toString(), LanguageCodeEnum.BASIC_ENGLISH.toString()].indexOf(lang.vmce) >= 0);
        return languages.map(language => {
            const item: IMultiLineValue = {
                text: "",
                flag: lang2flag(language.vmce),
                caption: language.nameDe
            };

            // get text(based on key)
            let modeltypeBasicTextDto = _.find(this.val.names, (text: ModelBasicNameDto) =>
                text.language && text.language.objectId === language.objectId && text[key] !== undefined);

            if (modeltypeBasicTextDto) {
                let optionText: string = modeltypeBasicTextDto[key];
                item.text = optionText;
            }

            return item;
        });
    }

    private setText(key: string, newValue: IMultiLineValue[]) {
        const lngtxts: IMultiLineValue[] = this.getText(key); // texts in the order and count like this.languages
        const chgtxts = _.map(lngtxts, (lngtxt: IMultiLineValue) => {
            const index = this.languages.findIndex(val => val.nameDe === lngtxt.caption);
            const language = this.languages[index];
            const chgtxt = _.find(newValue, (value: IMultiLineValue) =>
                lngtxt.flag === value.flag && lngtxt.text !== value.text);
            return chgtxt !== undefined ? {language, value: chgtxt} : undefined;
        });
        const {names = []} = this.val;
        _.forEach(chgtxts, (chgtxt) => {
            if (chgtxt === undefined)
                return;
            let name = _.find(names, (textDto: ModelBasicNameDto) => textDto.language !== undefined && chgtxt.language.objectId === textDto.language.objectId);
            if (name === undefined) {
                name = {objectId: 0, versionId: 0, language: {objectId: chgtxt.language.objectId}, name: 'test'};
                if (this.val.objectId > 0) {
                    name.objectId = this.val.objectId;
                }
                names.push(name);
            }
            if (_.isString((chgtxt.value as any).value))
                name[key] = (chgtxt.value as any).value;
            else if (_.isString(chgtxt.value.text))
                name[key] = chgtxt.value.text;
            else
                name[key] = undefined;
        });
        this.val.names = names;
    }
}



// WEBPACK FOOTER //
// ./src/views/ModeltypeBasicView/DataAdapterModeltypeBasic.tsx